// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3SauL","head":"Table_head__2bnL2","col":"Table_col__LKjB7"};